/**
 * Generate an array of days for the selected month
 * @param {Date} date - Date object containing the month to generate days for
 * @returns {Array<Date>} Array of Date objects for each day in the month
 */
export const generateDaysArray = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    
    return Array.from({ length: daysInMonth }, (_, i) => 
      new Date(year, month, i + 1)
    );
  };
  
  /**
   * Get the abbreviated day name for a date
   * @param {Date} date - Date to get the day name for
   * @returns {string} Abbreviated day name (Su, Mo, Tu, etc.)
   */
  export const getDayName = (date) => {
    const days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    return days[date.getDay()];
  };
  
  /**
   * Get the month and year string for a date
   * @param {Date} date - Date to get the month and year for
   * @returns {string} Month and year string (e.g. "August 2024")
   */
  export const getMonthYear = (date) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
  };
  
  export const formatDateForAWS = (date) => {
    return date.toISOString().split("T")[0];
  };
  